import { PersonTeaserData, Record } from '@/search/useSearchPerson/Interfaces';
import { SerializedPersonTeaser } from '@/search/useSearchPerson/serializer/personTeaserSerializer';

export class PersonTeaser {
  public data: Record[];

  constructor(rawData: PersonTeaserData) {
    this.data = SerializedPersonTeaser(rawData);
  }
}
